export class StringUtils {
  public static parseFloat(value: string | number): number | undefined {
    if (typeof value === 'number') {
      return value;
    }
    return parseFloat(value.replace(',', '.'));
  }

  /**
   * Parse a loosely-typed boolean (e.g. an env var). Truthy: `true`, `1`, `yes`,
   * `on` (case-insensitive, trimmed). Anything else — including `undefined`/`null`
   * and empty strings — is `false`.
   */
  public static parseBoolean(
    value: string | boolean | undefined | null,
  ): boolean {
    if (typeof value === 'boolean') {
      return value;
    }
    if (value == null) {
      return false;
    }
    return ['true', '1', 'yes', 'on'].includes(value.trim().toLowerCase());
  }
}
